class PaginationController {
  constructor($element) {
    'ngInject';

    this.$element = $element;
  }

  $onInit() {
    this.pageCount = 0;
    this.pages = [];

    this.hasSubscribed = false;
  }

  $onDestroy() {
    // Subscriptions can leak memory, always clean it if not used anymore.
    this.subscription.unsubscribe();
  }

  // Note that subscription will be done only once.
  $doCheck() {
    if (this.maxPageCount && this.subject && !this.hasSubscribed) {
      this.hasSubscribed = true;
      this.subscription = this.subject.subscribe((pagination) => {
        if (pagination) {
          // Note that the pagination object is required to have
          // the following properties or the pagination wouldn't work.
          this.limit = pagination.limit;
          this.page = pagination.page;
          this.total = pagination.total;
          this.totalFiltered = pagination.totalFiltered;

          this.refresh();
          this.draw(this.limit, this.totalFiltered);
        }
      });
    }
  }

  draw(limit, totalFiltered) {
    this.pageCount = this.getPageCount(limit, totalFiltered);

    if (this.pageCount <= 1) {
      return;
    }

    this.last = this.pageCount;
    this.current = this.page;

    let upperLimit, lowerLimit;
    let currentPage = lowerLimit = upperLimit = Math.min(this.current, this.total);

    for (let b = 1; b < this.maxPageCount; b++) {
      if (lowerLimit > 1 ) {
        lowerLimit--;
      }
      if (b < this.maxPageCount) {
        if (upperLimit < this.last) {
          upperLimit++;
        }
      }
    }

    for (let i = lowerLimit; i <= upperLimit; i++) {
      let page = {
        number: i,
        label: i,
        active: i === currentPage,
      };

      this.pages.push(page);
    }

    if (this.hasPrevious()) {
      let prevPage = {
        number: this.current - 1,
        label: '<',
      };

      this.pages.unshift(prevPage);
    }

    if (this.hasNext()) {
      let prevPage = {
        number: this.current + 1,
        label: '>',
      };

      this.pages.push(prevPage);
    }
  }

  hasPrevious() {
    return this.current > 1;
  }

  hasNext() {
    return this.current !== this.last;
  }

  getPageCount(limit, totalFiltered) {
    return Math.ceil(totalFiltered / limit);
  }

  refresh() {
    this.pages.length = 0;
  }

  click(page) {
    this.onPageClicked({ page: page });
  }
}

export default PaginationController;



// WEBPACK FOOTER //
// ./client/app/shared/ui/pagination/pagination.controller.js